module.exports = __webpack_public_path__ + "img/font_01@2x.9484b572.png";